import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=f15b5e76&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=f15b5e76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15b5e76",
  null
  
)

export default component.exports